import { render } from "./AppBanner.vue?vue&type=template&id=a73bd138"
import script from "./AppBanner.vue?vue&type=script&lang=js"
export * from "./AppBanner.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__